module.exports = __webpack_public_path__ + "static/media/13.03f36138.png";